export default __webpack_public_path__ + "static/media/menu-update-pwd-white.e23f3606.svg";